export default "__VITE_ASSET__BVlU3NFn__"